/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

export const radio_set_group = (block, generator) => {
  const group = generator.valueToCode(block, 'GROUP', generator.ORDER_ATOMIC);

  return `radio.setGroup(${group})\n`;
};

export const radio_send_number = (block, generator) => {
  const number = generator.valueToCode(block, 'NUMBER', generator.ORDER_ATOMIC);

  return `radio.sendNumber(${number})\n`;
};

// El + "" fuerza la conversión a texto, que es lo que espera sendString.
export const radio_send_string = (block, generator) => {
  const text = (generator.valueToCode(block, 'STRING', generator.ORDER_ATOMIC) || '').replace(/'/g, '');

  return `radio.sendString(${text} + "")\n`;
};

export const radio_send_number_label = (block, generator) => {
  const label = (generator.valueToCode(block, 'LABEL', generator.ORDER_ATOMIC) || '').replace(/'/g, '');
  const number = generator.valueToCode(block, 'NUMBER', generator.ORDER_ATOMIC);

  return `radio.sendValue(${label} + "", ${number})\n`;
};

// El tipo elegido define qué callback de radio se registra y con qué
// parámetros, que son los que después leen los tres bloques de lectura.
const RECEIVERS = {
  number: { fn: 'radio.onReceivedNumber', params: 'receivedNumber' },
  string: { fn: 'radio.onReceivedString', params: 'receivedString' },
  number_label: { fn: 'radio.onReceivedValue', params: 'receivedLabel, receivedNumber' },
};

export const radio_on_received_data = (block, generator) => {
  const { fn, params } = RECEIVERS[block.getFieldValue('TYPE')] || RECEIVERS.number_label;
  const branch = generator.statementToCode(block, 'DO').replace(/&quot;/g, '"');

  const code = `${fn}(function (${params}) {\n  ${branch}\n})\n`;
  if (typeof block !== 'undefined' && block.id) {
    generator.setups_[block.id] = code;
  }

  return '';
};

// Los tres leen los parámetros del callback que abre radio_on_received_data, así
// que sólo tienen sentido dentro de ese bloque.
export const radio_read_number = (block, generator) => ['receivedNumber', generator.ORDER_ATOMIC];

export const radio_read_string = (block, generator) => ['receivedString', generator.ORDER_ATOMIC];

export const radio_read_label = (block, generator) => ['receivedLabel', generator.ORDER_ATOMIC];
